<template>
  <b-container class="pb-4">
    <my-profile-form-payment-options />
  </b-container>
</template>

<script>
import MyProfileFormPaymentOptions from 'components/MyProfile/MyProfileFormPaymentOptions'

export default {
  name: 'PaymentOptionsPage',

  components: {
    MyProfileFormPaymentOptions
  }
}
</script>
